var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2House(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 45,
    viewBox: "0 0 62 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2993",
    "data-name": "Groupe 2993",
    transform: "translate(-161 -756)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dhj",
    transform: "translate(161.427 756.491)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M0,45V16.168L19.5,0l8.775,7.276V5.12h4.55v5.928L39,16.168V45Z",
    transform: "translate(-0.427 -0.491)",
    fill: "#01a3da"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_2",
    "data-name": "Path 2",
    transform: "translate(2.71 3.79)",
    fill: "#01a3da",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 32.56317901611328 37.62817764282227 L 0.749997615814209 37.62817764282227 L 0.749997615814209 13.71946430206299 L 16.65984344482422 0.9614310264587402 L 32.56317901611328 13.71937274932861 L 32.56317901611328 37.62817764282227 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 16.65974617004395 1.922863006591797 L 1.499998092651367 14.07939529418945 L 1.499998092651367 36.87817764282227 L 31.81317710876465 36.87817764282227 L 31.81317710876465 14.0792179107666 L 16.65974617004395 1.922863006591797 M 16.65993690490723 -3.814697265625e-06 L 33.31317901611328 13.35952758789062 L 33.31317901611328 38.37817764282227 L -3.814697265625e-06 38.37817764282227 L -3.814697265625e-06 13.35952758789062 L 16.65993690490723 -3.814697265625e-06 Z",
    stroke: "none",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(200.613 775.936)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape-2",
    "data-name": "Combined Shape",
    d: "M0,26V9.341L11.5,0l5.175,4.2V2.958h2.683V6.383L23,9.341V26Z",
    transform: "translate(-0.613 -0.936)",
    fill: "#e1f4fb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_2-2",
    "data-name": "Path 2",
    transform: "translate(1.393 1.993)",
    fill: "#e1f4fb",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 18.57902336120605 21.51784324645996 L 0.7500026226043701 21.51784324645996 L 0.7500026226043701 8.111421585083008 L 9.666359901428223 0.9614374041557312 L 18.57902336120605 8.111329078674316 L 18.57902336120605 21.51784324645996 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 9.666261672973633 1.922866821289062 L 1.500001907348633 8.471351623535156 L 1.500001907348633 20.76784324645996 L 17.82902336120605 20.76784324645996 L 17.82902336120605 8.471175193786621 L 9.666261672973633 1.922866821289062 M 9.666452407836914 3.814697265625e-06 L 19.32902336120605 7.751483917236328 L 19.32902336120605 22.26784324645996 L 1.9073486328125e-06 22.26784324645996 L 1.9073486328125e-06 7.751483917236328 L 9.666452407836914 3.814697265625e-06 Z",
    stroke: "none",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2House);
export default __webpack_public_path__ + "static/media/2house.e846b009e61ba3ba9b89c0cbe1b4f061.svg";
export { ForwardRef as ReactComponent };